module.exports = __webpack_public_path__ + "img/cns_pc24.fdf54b01.png";